import React from 'react'
import styled from 'styled-components'
import CountryFlag from './CountryFlag'

// Stylowany komponent flagi z obwódką dla list ofert
const StyledCountryFlag = styled(CountryFlag)`
  margin-right: 4px;
  width: 14px;
  height: 10px;
  border: 1px solid ${({ theme }) => theme.colors.mercury.hex()};
  border-radius: 2px;
  display: inline-block;
`

const OfferLocationFlag = ({ countryCode, ...props }) => {
  if (!countryCode) return null

  return <StyledCountryFlag countryCode={countryCode} {...props} />
}

export default OfferLocationFlag
